<!-- @format -->
<ng-container *transloco="let t">
  <sis-study-notification-box
    type="info"
    [tertiaryButtonText]="t('PLAN.SHOW_ATTAINMENT_DETAILS')"
    (tertiaryClickAction)="openAttainmentDetailsModal()">
    {{ t("PLAN.COURSE_UNIT_ATTAINED") }}
  </sis-study-notification-box>
</ng-container>
